import {GetterTree} from 'vuex'
import User from "../../UserManager/ts/User";

export const getters: GetterTree<any, any> = {

    getChatUsers(state, getters, rootState) {
        // Filter current user our
        return state.chatUsers.filter( (user: User) => rootState.user.id != user.id);
    }
};
